/**
 * An implementation of a collection with LINQ support (based off .NET).
 * @module CI
 * @submodule Collection
 * @class CI.Collection
 * @author Iain Brown
 */


export class Collection{
    test: string;
    oType: Object;
    items:Array<Object> = [];

    /**
     * Create a new CI.Collection
     * @class CI.Collection
     * @constructor
     * @example let myList = new CI.Collection();
     */
    constructor() {
        this.oType = undefined;
        this.items = [];
    }

    /**
     * Adds objects to the collection once a Object is added then only objects of the that type can be added
     * @method Add
     * @param {Object} Object - the Object to add to the collection
     * @example  myList.Add(new Car("Honda", "CR-V"));
     * @since 1.1.0
     */
    Add() {
        if (!this.oType) {
            this.oType = typeof (Object);
        }

        this.validate.call(this, Object);

        this.items.push(Object);
    }

    /**
     *Returns the count of items in the collection.
     *@method Count
     * @since 1.1.0
     */
    Count() {
        return this.items.length;
    }

    /**
     * Removes an item from the collection, or a range of items
     * @method RemoveByIndex
     * @param {number} from The id of the Object to remove, or the starting id if removing a range of objects
     * @param {number} to The end id of the Object to remove is removing a range of objects
     * @return {Collection}
     * @since 1.1.0
     */
    RemoveByIndex (from, to) {
        let rest = this.items.slice((to || from) + 1 || this.items.length);
        this.items.length = from < 0 ? this.items.length + from : from;
        return this.items.push.apply(this.items, rest);
    }

    /**
     * Removes a item from the collection
     * @method Remove
     * @param {Object} Object to remove from the collection
     * @return {Collection}
     * @since 1.1.0
     */
    Remove (item: Object) {
        if (!this.oType) {
            this.oType = typeof (Object);
        }

        this.validate.call(this, item);
        let index = this.items.indexOf(item);
        this.items.splice(index, 1);
        //let rest = this.items.slice((index || index) + 1 || this.items.length);
        //this.items.length = index < 0 ? this.items.length + index : index;
        //return this.items.push.apply(this.items, rest);

    }

    /**
     * Returns the Collection as JSON
     * @method SerializeToJSON
     * @return {string} JSON string of the Collection
     * @since 1.1.0
     */
    SerializeToJSON () {
        try {
            return JSON.stringify(this.items).toString();
        } catch (e) {

        }
    }

    /**
    @method validate
    @private
    */
    validate(Object) {

        if (typeof (Object) != this.oType) {
            throw "Only one Object type is allowed in a list";
        }
    }

    /**
     * Sets the Data of the collection only use is you wish to override the data in the collection with another collection.
     * @method Data
     * @param {array} dataArray Array of data to override the current collection with
     * @since 1.1.0
     */
    Data (dataArray) {
        this.items = dataArray;
    }

    /**
     * Returns a Object from the collection at a set index
     * @method ElementAt
     * @param {number}  index The id of the Object to return
     * @return {Object} returns an Object from the collection
     * @since 1.1.0
     */
    ElementAt (index) {

        if (index >= this.items.length || index < 0) {
            throw "Invalid index parameter in call to CI.collection.ElementAt";
        }
        return this.items[index];
    }

    /**
    * Returns a boolean where or not the collection containes the Object.
    * This uses the javascript JSON functions so will fail on older browsers
    * @method ContainesObject
    * @param {Object} Object the Object to look for
    * @return {boolean} if the Object was found.
    * @since 1.1.1
    */
    ContainesObject (Object) {

        if (!this.oType) {
            this.oType = typeof (Object);
        }

        this.validate.call(this, Object);
        for (let arrIndex = 0; arrIndex < this.items.length; arrIndex++) {
            if (JSON.stringify(this.items[arrIndex]) === JSON.stringify(Object)) {
                return true;

            }
        }
        return false;
    }

    

    /**
     * Return the idex of the Object in the Collection
     * This will return the index of the first instance of the Object
     * @method IndexOf
     * @param {Object} Object The Object to find the index of
     * @return {int} The location of the Object in the array
     * @since 1.1.0
     */
    IndexOf (Object) {

        if (!this.oType) {
            this.oType = typeof (Object);
        }

        this.validate.call(this, Object);
        for (let arrIndex = 0; arrIndex < this.items.length; arrIndex++) {
            if (JSON.stringify(this.items[arrIndex]) === JSON.stringify(Object)) {
                return arrIndex;

            }
        }
        return null;
    }

    

    /**
    @method copy
    @private
         * @since 1.1.0
    */
    cCIy(array) {
        let newList = new Collection();
        newList.Data(array);
        return newList;
    }

   

    

}